/* ============================================================
   melusio-quick-view.js — the quick-view overlay behaviour (Cut 3).

   Triggers are real <a href="{product.url}"> links (no-JS opens the PDP). JS
   intercepts, fetches the product's melusio-quick-view section via the Section
   Rendering API, injects it into a body-level host, and opens it. Selecting a
   size updates the CTA from the pill's PRE-FORMATTED price (no money math in JS).
   Adding delegates to window.MelusioCart.addItem, which opens the bag drawer;
   the overlay's one-at-a-time rule closes the quick-view.
   ============================================================ */
(function () {
  const HOST_ID = 'melusio-quick-view-host';
  const SECTION = 'melusio-quick-view';
  let controller = null;

  function host() {
    let h = document.getElementById(HOST_ID);
    if (!h) { h = document.createElement('div'); h.id = HOST_ID; document.body.appendChild(h); }
    return h;
  }

  async function openFor(url, trigger) {
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', SECTION);
    if (controller) controller.abort();
    controller = new AbortController();
    let html;
    try {
      const res = await fetch(u, { signal: controller.signal });
      if (!res.ok) { window.location.href = url; return; }
      html = await res.text();
    } catch (e) {
      if (e.name === 'AbortError') return;
      window.location.href = url; // network failure → fall back to the PDP
      return;
    }
    const h = host();
    h.innerHTML = html;
    const overlay = h.querySelector('melusio-overlay');
    if (!overlay) { window.location.href = url; return; }
    if (window.customElements && customElements.upgrade) customElements.upgrade(overlay);
    wire(overlay);
    if (overlay.show) overlay.show(trigger);
    else if (window.MelusioOverlay) window.MelusioOverlay.open('melusio-quick-view', trigger);
  }

  function wire(overlay) {
    // size selection + add-to-bag are the shared buy-box engine (melusio-buy-box.js);
    // on a successful add the bag drawer opens and closes us (safety net: close here too).
    if (window.MelusioBuyBox) {
      window.MelusioBuyBox.wire(overlay, { onAdded: () => { if (overlay.close) overlay.close(); } });
    }

    // Gallery. Thumbnail swap has two requirements for a snappy result:
    //  1) the main <img> has a srcset, so setting .src alone is ignored — swap srcset+sizes+src.
    //  2) the target rendition is fetched cold from the CDN (~1s) unless preloaded — so preload
    //     it just-in-time. Both use the per-thumb responsive values Liquid emitted (server truth).
    const mainImg = overlay.querySelector('.m-qv__stage img');
    if (mainImg) {
      const thumbs = Array.from(overlay.querySelectorAll('[data-qv-thumb]'));
      const preloaded = new Set();
      const preload = (t) => {
        const srcset = t.getAttribute('data-full-srcset');
        const full = t.getAttribute('data-full');
        const key = srcset || full;
        if (!key || preloaded.has(key)) return; // fetch each image at most once
        preloaded.add(key);
        const im = new Image();
        const sizes = t.getAttribute('data-full-sizes');
        if (sizes) im.sizes = sizes;
        if (srcset) im.srcset = srcset;
        if (full) im.src = full; // fallback when no srcset
      };
      thumbs.forEach((t) => {
        // desktop: preload on hover / keyboard focus so the click swap is instant (cached)
        t.addEventListener('pointerenter', () => preload(t));
        t.addEventListener('focus', () => preload(t));
        t.addEventListener('click', () => {
          const full = t.getAttribute('data-full');
          const fullSrcset = t.getAttribute('data-full-srcset');
          const fullSizes = t.getAttribute('data-full-sizes');
          if (fullSizes) mainImg.sizes = fullSizes;
          mainImg.srcset = fullSrcset || '';
          if (full) mainImg.src = full;
          thumbs.forEach((x) => x.classList.remove('is-active'));
          t.classList.add('is-active');
        });
      });
      // touch / no-hover: nothing to hover — preload all shortly after open (deferred, background)
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
        setTimeout(() => thumbs.forEach(preload), 300);
      }
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (!trigger) return;
    const url = trigger.getAttribute('href') || trigger.getAttribute('data-product-url');
    if (!url) return;
    e.preventDefault();
    openFor(url, trigger);
  });
})();
